/**
 * Hook for fetching milestone types lookup data
 * ✅ HARDCODED (2025-11-09): Custom milestones always enabled (production-forced)
 */

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { logger } from '@/lib/logger';
import { milestoneTypeRecordSchema, type MilestoneTypeRecord } from '@/schemas/milestone';

export const useMilestoneTypes = (options?: { enabled?: boolean }) => {
  // ✅ HARDCODED (2025-11-09): Always enabled (production-forced)
  const milestoneFeatureEnabled = true;

  return useQuery({
    queryKey: ['milestone-types'],
    queryFn: async () => {
      logger.debug('useMilestoneTypes', 'Fetching milestone types');

      const { data, error } = await supabase
        .from('milestone_types' as any)
        .select('name, display_name, color, description, is_active, sort_order, created_at, updated_at')
        .eq('is_active', true)
        .order('sort_order', { ascending: true });

      if (error) {
        logger.error('useMilestoneTypes', 'Failed to fetch milestone types', { error });
        throw error;
      }

      // Validate with Zod
      const validatedData = data.map(item => milestoneTypeRecordSchema.parse(item));

      logger.debug('useMilestoneTypes', 'Milestone types loaded', { count: validatedData.length });

      return validatedData;
    },
    enabled: milestoneFeatureEnabled && (options?.enabled !== false),
    staleTime: 5 * 60 * 1000, // 5 minutes - prevent perceived reloads
    refetchOnWindowFocus: true,
    refetchOnMount: true
  });
};
